import * as React from 'react';
import ReactEcharts from 'echarts-for-react';
import { TwoDimGraphProps } from '../types';

export default function AdvancedChart(
    props: TwoDimGraphProps,
): React.ReactElement {
    const { height, width } = props;
    const { eChartOptions } = props.settings;
    if (!eChartOptions) {
        throw new Error('Cannot render an advancedChart without echartOptions');
    }
    const options = JSON.parse(eChartOptions);
    return (
        <ReactEcharts
            option={options}
            style={{ height, width }}
            className="advanced-chart"
            opts={{ renderer: 'canvas' }}
        />
    );
}
